import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../../store';
import { ChatBuddyProps } from '../../Models/ChatBuddyProps';

// Define a type for the slice state
interface CounterState {
  buddy: ChatBuddyProps;
  status: 'IDLE' | 'PENDING' | 'SUCCESS' | 'FAILED';
}

// Define the initial state using that type
const initialState: CounterState = {
  buddy: {
    lastChatDate: '',
    firstName: '',
    publicId: '',
    unreadCount: 0,
    lastMessagePart: '',
    smallProfileUrl: '',
    description: '',
    largeProfileUrl: '',
    lastName: '',
    mediumProfileUrl: '',
    programme: '',
    replyTime: 0,
    replyTimeUnit: '',
    avgResponseTimeInMinutes: 0,
  },
  status: 'IDLE',
};

// Then, handle actions in your reducers:
// Then, handle actions in your reducers:
const SetSelectBuddySlice = createSlice({
  name: 'setSelectedBuddy',
  initialState: initialState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
    clearSelectedBuddy: (state) => {
      state.buddy = {
        lastChatDate: '',
        firstName: '',
        publicId: '',
        unreadCount: 0,
        lastMessagePart: '',
        smallProfileUrl: '',
        description: '',
        largeProfileUrl: '',
        lastName: '',
        mediumProfileUrl: '',
        programme: '',
        replyTime: 0,
        replyTimeUnit: '',
        avgResponseTimeInMinutes: 0,
      };
      state.status = 'IDLE';
    },
    setBuddyID: (state, action) => {
      state.buddy = action.payload;
    },
  },
});

export const setSelectedBuddySelector = (state: RootState) => state.selectedBuddy;

export const { clearSelectedBuddy, setBuddyID } = SetSelectBuddySlice.actions;

export default SetSelectBuddySlice.reducer;
